// gatsby-browser.js
import * as React from 'react';
import { CacheProvider } from '@emotion/react'
import createEmotionCache from './src/utils/createEmotionCache'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import theme from './src/theme'
import { ParallaxProvider } from 'react-scroll-parallax'
import './src/styles/global.css';

const clientSideEmotionCache = createEmotionCache();

export const wrapRootElement = ({ element }) => (
  <CacheProvider value={clientSideEmotionCache}>
    <ThemeProvider theme={theme}>
      <ParallaxProvider>
        <CssBaseline />
        {element}
      </ParallaxProvider>
    </ThemeProvider>
  </CacheProvider>
)
